<template>
  <div class="content-wrappper">
    <reports-header-tabs :hideTabs="hideTabs" :permissions="permissions"></reports-header-tabs>
    <router-view @hideTabs="displayTabs" :userRoleId="roleId"></router-view>
  </div>
</template>

<script>
import ReportsHeaderTabs from './ReportsHeaderTabs.vue';
import permissionsList from '../UIComponents/mixins/rbacPermissionsMixin';

export default {
  mixins: [permissionsList],
  components: {
    ReportsHeaderTabs,
  },
  props: ['roleId'],
  data() {
    return {
      hideTabs: false,
      permissions: [],
    };
  },
  async created() {
    await this.validateFeatures();
  },
  methods: {
    async validateFeatures() {
      this.permissions = [];
      const servicesList = ['REG_TRACKER'];
      const modulesList = ['REG_TRACKER_RECORDS', 'REG_TRACKER_REPORTS'];
      this.permissions = await this.permissionsList(servicesList, modulesList);
    },
    displayTabs(condition) {
      this.hideTabs = condition;
    },
  },
};
</script>
<style scoped>
 ::v-deep .dropdown-export {
	padding-right: 33px;
}
 ::v-deep .sub-content {
	font-size: 15px;
}

</style>
